import { usePet } from "^/common/usePet";
import { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { SwiperDataType } from "@/SwiperX";
import { useNewNotice } from "../../../api/services/customer/home";

interface PetProductList {
  companySeq: number;
  companyName: string;
  companyAddr: string;
  img_url: string;
}

// interface ScheduleNoticeData {
//     noticeMessage: string | null;
//     petProductList: PetProductList[];
// }

const useHome = () => {
  const { usePetList, usePetCalendarList, usePetScheduleList } = usePet();
  const [selectedPetSeq, setSelectedPetSeq] = useState<string>();
  const [noticeMessage, setNoticeMessage] = useState<string>();
  const [productList, setProductList] = useState<SwiperDataType[]>([]);
  const [currentDate] = useState(() => new Date());

  const currentYearMonth = format(currentDate, "yyyyMMdd");

  const { data: petList } = usePetList();
  const { data: calendarData } = usePetCalendarList({
    petSeq: selectedPetSeq || "",
    yearMonthDay: currentYearMonth,
  });
  const { data: scheduleNoticeData } = usePetScheduleList({
    petSeq: selectedPetSeq || "",
  });
  const { data: newNoticeData } = useNewNotice();

  // 진입 시 첫 번째 반려동물을 기본 선택
  useEffect(() => {
    if (!selectedPetSeq && petList?.length) {
      setSelectedPetSeq(petList[0].petSeq.toString());
    }
  }, [petList, selectedPetSeq]);

  useEffect(() => {
    if (scheduleNoticeData) {
      setNoticeMessage(scheduleNoticeData.noticeMassage);
      const result = scheduleNoticeData.petProductList.map(
        (item: PetProductList) => {
          return {
            title: item.companyName,
            description: item.companyAddr,
            image: item.img_url,
            seq: item.companySeq.toString(),
          };
        }
      );
      setProductList(result);
    }
  }, [scheduleNoticeData]);

  const handlePetSelect = useCallback(
    (data: { value: string; label: string }) => {
      console.log(data);
      setSelectedPetSeq(data.value);
    },
    []
  );

  return {
    petList,
    calendarData,
    selectedPetSeq,
    currentDate,
    handlePetSelect,
    noticeMessage,
    productList,
    newNoticeData,
  };
};

export default useHome;
